/** Commercial comparisons use the full twelve monthly payments. */
export const BLACK_STANDARD_SAVING = 207 * 12 - 1997;
export const BLACK_SPECIAL_SAVING = 177 * 12 - 1644;
export const BLACK_CHECKOUT_OPENS_AT = Date.parse("2026-10-26T08:00:00-03:00");
export const BLACK_CHECKOUT_CLOSES_AT = Date.parse("2026-11-04T01:00:00-03:00");
export const BLACK_CLOSED_CONTACT_URL = "https://nimble.li/vdr257p9";
export const BLACK_PUBLIC_OPENS_AT = Date.parse("2026-10-26T10:00:00-03:00");

export function isBlackPublicOpen(now: number): boolean {
  return now >= BLACK_PUBLIC_OPENS_AT;
}

export function isBlackCaptureOpen(now: number): boolean {
  return !isBlackPublicOpen(now);
}

export function assertBlackCaptureOpen(now: number, entregas = false): void {
  if (isBlackCaptureOpen(now)) return;
  throw Response.json({ ok: false, closed: true, redirect: entregas ? "/black-oferta-entregas" : "/black-oferta", error: "A captação da Black foi encerrada. Acesse a oferta." }, { status: 410 });
}

/** Preserve campaign attribution, hashes and unrelated routes. */
export function blackScheduledHref(href: string, now: number): string {
  if (!isBlackPublicOpen(now)) return href;
  return href.replace(/(^|\/)(black-lista-entregas|black-lista|black-quizz)(?=[?#]|$)/, (_, prefix: string, path: string) =>
    `${prefix}${path === "black-lista-entregas" ? "black-oferta-entregas" : "black-oferta"}`);
}

export function isBlackCheckoutOpen(now: number): boolean {
  return now >= BLACK_CHECKOUT_OPENS_AT && !isBlackOfferClosed(now);
}

export function isBlackOfferClosed(now: number): boolean {
  return now >= BLACK_CHECKOUT_CLOSES_AT;
}